import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const catchNotFound =
  (router: Router, notFoundPage: string[]) =>
  <T>(source: Observable<T>): Observable<T> =>
    source.pipe(
      catchError((error) => {
        if (error.error.status === 404 || error.status === 404) {
          router.navigate(notFoundPage, { skipLocationChange: true });
        }

        return throwError(error);
      })
    );
